<script>
	import { push } from "svelte-spa-router";
	import Username from "../../components/Username.svelte";
	import Logo from "../../components/Logo.svelte";
	import GameNameEnums from "../../enums/GameName";
</script>

<div class="container-global">
	<div class="container-header">
		<div class="header">
			<Logo src="./favicon.png" />
			<div class="top-header">
				<div class="top-header text-3xl">Reactivity</div>
			</div>
		</div>
	</div>
	<div class="content flex flex-col items-center pt-8">
		<div class="mb-3">
			<Username />
		</div>
		{#each GameNameEnums.url() as game}
			<button class="button-reactivity-bg my-3" on:click={() => push('/'+game)}>
				{GameNameEnums.label(game)}
			</button>
		{/each}
	</div>
</div>
